/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */
import msk from 'msk';
import moment from 'moment';
import cpf from 'node-cpf';
import { parseDate } from './dateParser';

const FIELDS = {
  NAME: {
    key: 'fullname',
    error: 'Erro no nome: Utilize nome e sobrenome',
  },
  CPF: {
    key: 'documentId',
    error: 'Erro no CPF: Utilize um cpf válido',
  },
  EMAIL: {
    key: 'email',
    error: 'Erro no Email: Utilize @ e ponto (.).',
  },
  BIRTHDATE: {
    key: 'birthdate',
    error: 'Erro na data de nascimento: Utilize o formato DD/MM/YYYY.',
  },
  PHONENUMBER: {
    key: 'phoneNumber',
    error: 'Erro no telefone: Utilize o padrão (xx) xxxxy-xxxx',
  },
  GENDER: {
    key: 'gender',
    error: 'Erro no gênero: Utilize Masculino ou Feminino',
  },
  MOTHERSNAME: {
    key: 'mothersName',
    error: 'Erro no nome completo da mãe: Utilize nome e sobrenome',
  },
  RESPONSIBLE: {
    key: 'responsible',
    error: 'Erro no nome completo do responsável: Utilize nome e sobrenome',
  },
  PATIENTTYPE: {
    key: 'patientType',
    error: 'Erro na característica do paciente: Utilize um dos seguintes padrões: Profissional de Segurança,'
            + ' Profissional de Saúde, Profissional do Sistema Carcerário, Outro',
  },
  COUNTRY: {
    key: 'country',
    error: 'Erro no país: Utilize o nome do país',
  },
  STATE: {
    key: 'state',
    error: 'Erro no estado: Utilize a sigla do estado no padrão XX',
  },
  CITY: {
    key: 'city',
    error: 'Erro na cidade: Utilize o nome da cidade',
  },
  ZIPCODE: {
    key: 'zipCode',
    error: 'Erro no CEP: Utilize o padrão xx.xxx-xxx',
  },
  STREET: {
    key: 'street',
    error: 'Erro na rua: Utilize o nome da rua',
  },
  HOUSENUMBER: {
    key: 'houseNumber',
    error: 'Erro no número do endereço: Utilize o número do endereço',
  },
  UNITNUMBER: {
    key: 'unitNumber',
    error: 'Erro no complemento: opcional',
  },
  NEIGHBORHOOD: {
    key: 'neighborhood',
    error: 'Erro no bairro: Utilize o nome do bairro',
  },
};

const getValidatedRow = (item, createEmail) => {
  const fields = Object.keys(item);
  const errors = [];
  const validated = {};
  const maskedRow = {};

  const capitalize = (data) => {
    if (typeof data !== 'string') return '';

    return data.charAt(0).toUpperCase() + data.slice(1).toLowerCase();
  };

  const isValidName = (name) => /^[^\s]{2}.*\s.+[^\s]$/.test(name);

  const isValidTwoLetler = (data) => /[a-zA-Z]{2}/.test(data);

  const validateField = (field, value) => {
    switch (field) {
      case FIELDS.NAME.key:
        if (!isValidName(value)) {
          errors.push(FIELDS.NAME.error);
        }
        return value;
      case FIELDS.CPF.key:
        const cpfNumbers = value.replace(/\D/g, '');
        const isValidCpf = cpf.validate(cpfNumbers);
        if (!isValidCpf) {
          errors.push(FIELDS.CPF.error);
          return value;
        }
        const valueMasked = msk(cpfNumbers, '999.999.999-99');
        return valueMasked;
      case FIELDS.EMAIL.key:
        // eslint-disable-next-line max-len
        const isValidEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value?.toLowerCase());
        if (!isValidEmail) {
          errors.push(FIELDS.EMAIL.error);
        }
        return value;
      case FIELDS.BIRTHDATE.key:
        if (value.includes('/') && !value.match(/\/(\d{4})$/)) {
          errors.push(FIELDS.BIRTHDATE.error);
          return value;
        }

        if (!value.includes('/') && value.length !== 8) {
          errors.push(FIELDS.BIRTHDATE.error);
          return value;
        }
        const isValidBirthDate = moment(value, 'DD/MM/YYYY', false);
        if (!isValidBirthDate.isValid()) {
          errors.push(FIELDS.BIRTHDATE.error);
          return value;
        }
        // Is BirthDate future
        if (moment().diff(isValidBirthDate) < 0) {
          errors.push(FIELDS.BIRTHDATE.error);
        }
        return value;
      case FIELDS.PHONENUMBER.key:
        const phoneNumber = value.replace(/(^0)|(\(0)|\D/g, '');
        if (phoneNumber.length === 10) {
          return msk(phoneNumber, '(99) 9999-9999');
        }
        if (phoneNumber.length === 11) {
          return msk(phoneNumber, '(99) 99999-9999');
        }
        errors.push(FIELDS.PHONENUMBER.error);
        return value;
      case FIELDS.GENDER.key:
        const isValidGender = /^(Masculino|Feminino)$/gi.test(value);
        if (!isValidGender) {
          errors.push(FIELDS.GENDER.error);
          return value;
        }
        return capitalize(value);
      case FIELDS.MOTHERSNAME.key:
        if (!isValidName(value)) {
          errors.push(FIELDS.MOTHERSNAME.error);
        }
        return value;
      case FIELDS.RESPONSIBLE.key:
        const birthDate = moment(item[FIELDS.BIRTHDATE.key], 'DD/MM/YYYY', false);
        if (!birthDate.isValid()) {
          return value;
        }

        const diffTime = moment().diff(birthDate, 'years');
        if (diffTime < 0 || diffTime >= 18) {
          return value;
        }

        if (diffTime < 18) {
          if (!isValidName(value)) {
            errors.push(FIELDS.RESPONSIBLE.error);
          }
        }
        return value;
      case FIELDS.PATIENTTYPE.key:
        if (/^Profissional de Seguran[çc]a$/gi.test(value)) {
          return 'Profissional de Segurança';
        } if (/^Profissional de Sa[úu]de$/gi.test(value)) {
          return 'Profissional de Saúde';
        } if (/^Profissional do Sistema Carcer[áa]rio$/gi.test(value)) {
          return 'Profissional do Sistema Carcerário';
        } if (/^Outro$/gi.test(value)) {
          return 'Outro';
        }
        errors.push(FIELDS.PATIENTTYPE.error);

        return value;
      case FIELDS.COUNTRY.key:
        if (!isValidTwoLetler(value)) {
          errors.push(FIELDS.COUNTRY.error);
        }
        return value;
      case FIELDS.STATE.key:
        const isValidState = /^[a-zA-Z]{2}$/.test(value);
        if (!isValidState) {
          errors.push(FIELDS.STATE.error);
          return value;
        }
        return value.toUpperCase();
      case FIELDS.CITY.key:
        if (!isValidTwoLetler(value)) {
          errors.push(FIELDS.CITY.error);
        }
        return value;
      case FIELDS.ZIPCODE.key:
        const zipCode = value.replace(/\D/g, '');
        if (zipCode.length !== 8) {
          errors.push(FIELDS.ZIPCODE.error);
          return value;
        }
        return msk(zipCode, '99.999-999');
      case FIELDS.STREET.key:
        const isValidStreet = /[a-zA-Z]|[0-9]/.test(value);
        if (!isValidStreet) {
          errors.push(FIELDS.STREET.error);
        }
        return value;
      case FIELDS.HOUSENUMBER.key:
        if (!value) {
          errors.push(FIELDS.HOUSENUMBER.error);
        }
        return value;
      case FIELDS.NEIGHBORHOOD.key:
        if (!isValidTwoLetler(value)) {
          errors.push(FIELDS.NEIGHBORHOOD.error);
        }
        return value;
      default:
        return value;
    }
  };

  let empty = 0;
  fields.forEach((key) => {
    const value = item[key];
    if (value === null || value === undefined || value === '') {
      empty += 1;
    }
  });

  if (empty === fields.length) {
    return null;
  }

  fields.forEach((key) => {
    // create fake email if needed
    if (createEmail && key === FIELDS.EMAIL.key) {
      if (!item[key] || item[key] === '') {
        item[key] = `${msk(item[FIELDS.CPF.key], '999.999.999-99')}@iniciativacovid19.com.br`;
      }
    }

    const data = item[key];

    const value = validateField(key, String(data).trim());
    maskedRow[key] = data ? value : data;
    validated[key] = {
      value,
      errors,
    };
  });

  return {
    validated,
    maskedRow,
  };
};

export const isEmptyLine = (item) => {
  for (const key in item) {
    if (item[key] !== null && item[key] !== "")
      return false;
  }
  return true;
}

export const hasEmptyEmails = (data) => {
  const empty = [];
  data.forEach((row, index) => {
    if (isEmptyLine(row)) return;
    if (!row) return;
    Object.keys(row).forEach((key) => {
      if (key === FIELDS.EMAIL.key) {
        if (!row[key] || row[key] === '') {
          empty.push(row);
        }
      }
    });
  });
  return empty.length;
};

export const validateRow = (item) => {
  const validRow = getValidatedRow(item);
  if (!validRow) return null;
  const { validated } = validRow;
  return validated && Object.values(validated).filter((field) => field.errors.length > 0);
};

export const getMaskedRow = (item, createEmail) => {
  const validRow = getValidatedRow(item, createEmail);
  if (!validRow) return null;
  const { maskedRow } = validRow;
  return maskedRow;
};

// return list of lines with errors
export const getLogErrors = (data) => {
  let errorObject = {};
  // eslint-disable-next-line array-callback-return
  data.forEach((item, index) => {
    const validRow = getValidatedRow(item);
    if (!validRow?.validated) return;
    const { validated } = validRow;
    const validatedRow = Object.values(validated);
    // eslint-disable-next-line array-callback-return
    validatedRow.map(({ value, errors }) => {
      if (errors?.length > 0) {
        errorObject = {
          ...errorObject,
          [index]: {
            line: index + 1,
            errors,
          },
        };
      }
    });
  });

  const keys = Object.keys(errorObject);
  let result = '';
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < keys.length; i++) {
    result += `linha ${Number(
      Object.values(errorObject)[i].line + 1,
    )}: ${
      Object.values(errorObject)[i].errors.join('\n\t')} \n\n`;
  }

  return result;
};
